import { Centrifuge } from 'centrifuge';
import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import routes from 'actions/routes';
import basePath from 'actions/basePath';
import notificationsActions from 'actions/notifications';
import subscriptionActions from 'actions/subscription';
import userActions from 'actions/user';
import authActions from 'actions/auth/auth';
import roleActions from 'actions/role';
import { NotificationInfo, PhoneCallMessage, Notification, STATUS_TYPES } from 'dyl-components';
import axiosInstance from 'actions/axiosInstance';
import NotificationPopupModals from "shared/modals/NotificationPopUpModals";
import SendEmailModal from "shared/modals/SendEmailModal";
import AddTaskModal from "shared/modals/AddTaskModal";
import AddEventModal from "shared/modals/AddEventModal";
import types from "actions/call/types.js";
import office_view from 'actions/office_view';
import leftSidebar from 'actions/left_sidebar_ui';
import contactsActions from 'actions/contacts';
import { useNavigate, useLocation, matchPath, useParams } from 'react-router-dom';
import phoneUtils from "utils/PhoneUtil";
import officeViewActions from 'actions/office_view';
import callTypes from "actions/office_view/types";
import appActions from 'actions/app/app';
import textActions from 'actions/text';
import campaignsActions from 'actions/campaigns';
import campaignContactsActions from 'actions/campaign_contacts';
import campaignHistoryActions from 'actions/campaign_history';
import campaignSessionSummaryActions from 'actions/campaign_session_summary';

const CHANNELS = {
    permission: 'perm',
    chat: 'chat',
    notification: 'notify',
    voip: 'voip',
    simulate: 'simulate',
    customer_status: 'customer_status',
    texting: 'texting',
    lead_status: 'lead_status'
}

const WebsocketConnection = ({phone, ws}) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { id } = useParams();
    const { pathname } = useLocation();
    const settings = pathname.split('/')[1];
    const { customer_id, user_id, isSimulating, feature } = useSelector(state => state.auth);
    let {ws_token} = useSelector(state => state.auth);
    const {
        notificationCalls,
        calls,
        savedSettingsRoute,
        displayedMessages,
        userPhoneCreds,
        isHardPhone,
        currentCall,
        leadConnect,
        dialer
    } = useSelector((state) => {
        const userPhoneCreds = state.officeView.creds.extension;
        const calls = state.officeView.calls;
        const notificationCalls = [];
        for (const key in calls) {
            if (calls.hasOwnProperty(key)) {
                if (state.officeView.extensions[userPhoneCreds]?.includes(key)) {
                    calls[key].channel_uuid = calls[key]?.legs?.find(leg => leg.extension === userPhoneCreds)?.channel_uuid
                    notificationCalls.push(calls[key])
                }
            }
        }
        const displayedMessages = phoneUtils.getDisplayedIncomingCalls(state.officeView);
        return {
            displayedMessages,
            notificationCalls,

            calls,
            savedSettingsRoute: state.app.savedSettingsRoute,
            userPhoneCreds,
            isHardPhone: state.pbx_config.isHardPhone,
            currentCall: state.officeView.currentCall,
            leadConnect: !!!state.officeView.creds?.lead_connect,
            dialer: state.officeView.dialer
        }
    })

    const currentCallRef = useRef(currentCall);
    const settingsRef = useRef(settings);
    useEffect(() => { settingsRef.current = settings; }, [settings]);
    const leadConnectRef = useRef(leadConnect);
    useEffect(() => { leadConnectRef.current = leadConnect; }, [leadConnect]);
    const [ messageQueue, setMessageQueue ] = useState([])
    let messageQueueCheck = [];

    const getTokenWS = async () => {
        //No need to call check twice it is already called in with Auth
        //let { ws_token } = await dispatch(authActions.check()) || {};
        //check whether we persit conneciton token
        if(!ws_token){
            try {
                const tokenInfo = await axiosInstance.instance1.get(`${routes.WEBSOCKET}/connect`)
                ws_token = tokenInfo.data.feToken;
            } catch(e){
                console.log("|+|Websocket Connection Failure",e)
            }
        } 
        return (ws_token)
    }

    if (! ws.current || Object.keys(ws.current).length === 0) {
        ws.current = new Centrifuge(`${basePath.VIEW_HOST}`, {
            debug: true,
            getToken: () => getTokenWS()
        });
    }

    const onDismissNotification = (id) => {
        let incomingNotification = messageQueueCheck;
        setTimeout(() => {
            const indexToRemove = incomingNotification.findIndex(notification => notification.notification_id === id);
            incomingNotification.splice(indexToRemove, 1);

            const notification = document.getElementsByClassName(`Notification--${id}`);
            if(notification.length === 1){
                notification[0].remove();
                setMessageQueue(incomingNotification);
            }
        }, (7000)); //Time Interval to Dismiss incoming message
    }

    useEffect(() => {
            const centrifuge = ws.current;
            if (!customer_id || !user_id || centrifuge.dylSubscribed) {
                return;
            }
            centrifuge.dylSubscribed = true;

            centrifuge.on('connect', (context) => {
                console.log("|+|Connect Context",context);
            });
            centrifuge.on('error', (e) => {
                console.log('|+|Centrifuge Error: ',e);
            });
            centrifuge.on('disconnect', (context) => {
                console.log("|+|Centrifuge Disconnect",context);
            })
            
            centrifuge.connect()

            //notifications
            const notificationSub = centrifuge.newSubscription(`${CHANNELS.notification}_${customer_id}_${user_id}`);
            notificationSub.on('subscribing', (msg) => {
            });
            notificationSub.on('subscribed', (msg) => {
                console.log('|+|Notification Subscribed', msg);
            });
            notificationSub.on('unsubscribed', (msg) => {
            });
            notificationSub.on('publication', (msg) => {
                const message = msg.data;
                dispatch(notificationsActions.hasUnReadNotifications());
                dispatch(notificationsActions.onReadNotificationCenter());
                setMessageQueue(prevQueue => [...prevQueue, message]);
                messageQueueCheck.push(message) 
                onDismissNotification(message.notification_id);
                if (message.notification_type === "campaign") {
                    const pathname = window.location.pathname;
                    const notificationCampaignId = message.notification_details?.campaign_id;
                    if (notificationCampaignId === Number(id)) {
                        dispatch(campaignsActions.readCampaign(notificationCampaignId));
                        if (!!(matchPath("/campaigns/:id/contacts", pathname))) {
                            const query = Object.fromEntries(new URLSearchParams(window.location.search));
                            dispatch(campaignContactsActions.readCampaignContacts(notificationCampaignId, query));
                        } else if (!!(matchPath("/campaigns/:id/history", pathname))) {
                            dispatch(campaignHistoryActions.readCampaignHistory(notificationCampaignId));
                        } else if (!!(matchPath("/campaigns/:id/session-summary/text", pathname))) {
                            dispatch(campaignSessionSummaryActions.readTextCampaignSessionsSummary(notificationCampaignId));
                        } else if (!!(matchPath("/campaigns/:id/session-summary/dialer", pathname))) {
                            dispatch(campaignSessionSummaryActions.readDialerSessionSummary(notificationCampaignId))
                        }
                    }
                }
            });
            notificationSub.subscribe();

            const simulateSub = centrifuge.newSubscription(`${CHANNELS.simulate}_${customer_id}_${user_id}`);
            simulateSub.on('subscribing', (msg) => {
                // console.log('|+|Simulate Subscribing...', msg);
            });
            simulateSub.on('subscribed', (msg) => {
                console.log('|+|Simulate Subscribed', msg);
            });
            simulateSub.on('unsubscribed', (msg) => {
                // console.log('|+|Simulate Unsubscribed', msg);
            });
            simulateSub.on('publication', (msg) => {
                const msgType = msg.data.type;
                if (msgType === "exit_simulate" && isSimulating) {
                    window.location.href = basePath.SALES_HOST;
                } else if (msgType === "replace_simulate"&& isSimulating) {
                    window.location.reload();

                }
            });
            simulateSub.subscribe();

            //permissions
            const permissionsSub = centrifuge.newSubscription(`${CHANNELS.permission}_${customer_id}_${user_id}`);
            permissionsSub.on('subscribing', (msg) => {
                // console.log('|+|Permission Subscribing...', msg);
            });
            permissionsSub.on('subscribed', (msg) => {
                console.log('|+|Permission Subscribed', msg);
            });
            permissionsSub.on('unsubscribed', (msg) => {
                // console.log('|+|Permission Unsubscribed', msg);
            });
            permissionsSub.on('publication', (msg) => {
                switch(msg.data.type) {
                    case 'update':
                        //get productPermissions
                        dispatch(subscriptionActions.getProductFeatures(customer_id)); 
                        //get userPermissions
                        dispatch(roleActions.readUserRoleSet(customer_id, {}, msg.data.access_role_id));                        
                        //Refresh userProfile 
                        dispatch(userActions.viewUserProfile(msg.data.user_id));
                        //Refresh passport
                        dispatch(authActions.check()); 
                        break;
                    case 'delete':
                        Notification.alert("Administrator removed access.", STATUS_TYPES.ERROR);
                        //Check authentication and kick user out
                        dispatch(authActions.check()); 
                        break;
                    default:
                        console.log("|+|Message Error: ", msg)
                        break;
                } 
            });
            permissionsSub.subscribe();

            //VOIP
            const voipChannel = feature ? `${CHANNELS.voip}_${customer_id}_${feature}` : `${CHANNELS.voip}_${customer_id}`;
            const voipSub = centrifuge.newSubscription(voipChannel);
            voipSub.on('subscribing', (msg) => {
                // console.log('|+|VOIP Subscribing...', msg);
            });
            voipSub.on('subscribed', (msg) => {
                console.log('|+|VOIP Subscribed', msg);
                dispatch(officeViewActions.getActiveCalls())
            });
            voipSub.on('unsubscribed', (msg) => {
                // console.log('|+|VOIP Unsubscribed', msg);
            });
            voipSub.on('publication', (msg) => {
                console.log("|+|VOIP_Message: ", msg);
                const call = msg.data.message;
                switch (msg.data.event) {
                    case 'contact_merge':
                        dispatch({type: "CONTACT_MERGE", contact: msg.data.contact, calls: msg.data.calls})
                        break;
                    case 'channel_bridge':
                        const user = call.legs.find(l => l.user_id === user_id);
                        if(leadConnectRef.current || (user && call.call_type === 'dialer')){
                             dispatch({type: types.CONNECT_CALL, call: call, leg: msg.data.leg_uuid, user_id})
                        }
                        const callIDs = phoneUtils.phoneDeviceCallIDs(call, phone, user?.extension);
                        if (user && !!!phoneUtils.phoneDeviceSession(callIDs.sessionID, phone)) {
                            //hardphone only
                            if (call.call_type !== 'dialer') {
                                if(leadConnectRef.current){
                                    dispatch(leftSidebar.onSetActiveSecondarySidebar("view"))
                                }
                                dispatch(office_view.onClosePhoneNotifications("CLOSE_CALL_NOTIFICATIONS"))
                                dispatch(office_view.currentCallPhoneNumber('CALL_CURRENT_NUMBER', call.direction === "internal" ? callIDs?.leg.extension : callIDs?.leg?.phone));
                                dispatch(office_view.currentCall('CURRENT_CALL', call.uuid));
                            }
                            if(settingsRef.current === "settings"){
                                //Settings Page
                                navigate(savedSettingsRoute);
                                dispatch(appActions.onSaveSettingsRoute(""));
                            }
                        }
                        break;
                    case 'channel_hangup':
                        dispatch({type: types.END_CALL, call: call, leg: msg.data.leg_uuid, user_id})
                        break;
                    case 'channel_create':
                        const userLeg = call.legs.find(l => l.user_id === user_id);
                        if(leadConnectRef.current || (userLeg && call.call_type === 'dialer')){
                            dispatch({type: types.NEW_CALL, call: call, leg: msg.data.leg_uuid, user_id })
                        }
                        if (userLeg && (!call.ringing_agent ||  userLeg.channel_uuid)) {
                            const cleg = call.legs.find(l => (!! l.contact_id || !! l.account_id));
                            const c2dUser = call.legs.find(l => l.extension === userLeg?.extension);
                            const callIDs = phoneUtils.phoneDeviceCallIDs(call, phone, userLeg?.extension);
                            if (cleg) {
                                const id = cleg.contact_id || cleg.account_id;
                                if (id && !currentCallRef.current && call.call_type !== "dialer") {
                                    dispatch(contactsActions.viewLookup(id, { call_uuid : call.uuid}));
                                }
                            }
                            if(call.direction === "internal" && c2dUser?.channel_uuid){
                                dispatch(office_view.userLookup({ user_ids: [callIDs?.leg?.user_id] }));
                                dispatch(office_view.currentCallPhoneNumber('CALL_CURRENT_NUMBER', callIDs?.leg.extension));
                            }
                            if (!!!phoneUtils.phoneDeviceSession(callIDs.sessionID, phone) && (call.direction === "outbound" || (call.direction === "internal" && call.uuid === userLeg.channel_uuid))) {
                                //outbound hardphone only
                                if(!call.ringing_agent && call.call_type !== "click2dial" && call.call_type !== "newlead" && call.call_type !== "sequence" && call.call_type !== "callback" && call.call_type !== "task" && call.call_type !== "dialer"){
                                    dispatch(leftSidebar.onSetActiveSecondarySidebar("view"));
                                    dispatch(office_view.currentCallPhoneNumber('CALL_CURRENT_NUMBER', call.direction === "internal" ? callIDs?.leg.extension : callIDs?.leg?.phone));
                                    if (call?.uuid !== state?.officeView?.currentCall) {
                                        dispatch(office_view.currentCall('CURRENT_CALL', call.uuid))
                                    }
                                    if(call.direction === "internal" ){
                                        dispatch(office_view.userLookup({ user_ids: [callIDs?.leg?.user_id] }));
                                    } else {
                                        dispatch(office_view.contactLookup('CONTACT_LOOKUP', call.uuid));
                                    }
                                }
                            }
                            if(call.call_type === "click2dial" && leadConnectRef.current){
                                //enable view open for click2dial and NOT lead connect
                                dispatch(leftSidebar.onSetActiveSecondarySidebar("view"));
                                if(settingsRef.current === "settings"){
                                    //Settings Page
                                    navigate(savedSettingsRoute);
                                    dispatch(appActions.onSaveSettingsRoute(""));
                                }
                            }
                        }
                        break;
                    case 'queue_end':
                        dispatch({
                            type: types.QUEUE_END,
                            call: call,
                        });
                        break;
                    case 'queue':
                        dispatch({
                            type: types.QUEUE,
                            call: call,
                        });
                        break;
                    case 'call_recording':
                        dispatch(office_view.callRecording('CALL_RECORDING', msg.data.data));
                        break;
                    case 'pressed':
                        dispatch({ type: types.PRESSED, call });
                        break;
                    default:
                        console.log("|+|Message Error: ", msg)
                        break;
                }
            });
            voipSub.subscribe();

            const customerStatusSub = centrifuge.newSubscription(`${CHANNELS.customer_status}_${customer_id}`);
            customerStatusSub.on('subscribing', (msg) => {
                // console.log('|+|Customer Status Subscribing...', msg);
            });
            customerStatusSub.on('subscribed', (msg) => {
                console.log('|+|Customer Status Subscribed', msg);
            });
            customerStatusSub.on('unsubscribed', (msg) => {
                // console.log('|+|Customer Status Unsubscribed', msg);
            });
            customerStatusSub.on('publication', (msg) => {
                console.log('|+|Customer Status Publication', msg);
                switch(msg.data.type) {
                    case 'logout':
                        dispatch(authActions.logout());
                        break;
                    default:
                        console.log("|+|Message Error: ", msg)
                        break;
                }
            });
            customerStatusSub.subscribe();

            const textingSub = centrifuge.newSubscription(`${CHANNELS.texting}_${customer_id}`);
            textingSub.on('subscribing', (msg) => {
            });
            textingSub.on('subscribed', (msg) => {
                console.log('|+|Texting Subscribed', msg);
            });
            textingSub.on('unsubscribed', (msg) => {
            });
            textingSub.on('publication', (msg) => {
                const message = msg.data;
                if (message.data.message?.toUpperCase() === 'STOP' || message.data.message?.toUpperCase() === 'START') {
                    dispatch(textActions.getUnsubscribed());
                }
                if (message.event === 'refresh_text') {
                    dispatch(textActions.refreshTextingComponents({ from: message.data?.from, to: message.data?.to }));
                }
                if (message.event === 'refresh_conversation') {
                    dispatch(textActions.refreshTextConversationComponents({ from: message.data?.to, to: message.data?.from }));
                }
            });
            textingSub.subscribe();

            const leadStatusSub = centrifuge.newSubscription(`${CHANNELS.lead_status}_${customer_id}_${user_id}`);
            leadStatusSub.on('subscribing', (msg) => {
            });
            leadStatusSub.on('subscribed', (msg) => {
                console.log('|+|Lead Status Subscribed', msg);
            });
            leadStatusSub.on('unsubscribed', (msg) => {
            });
            leadStatusSub.on('publication', (msg) => {
                const message = msg.data;
                if (message.event === 'lead_status_updated') {
                    dispatch(authActions.check());
                }
            });
            leadStatusSub.subscribe();

            //unMount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [customer_id, user_id, ws, dispatch, isSimulating, messageQueueCheck, navigate, onDismissNotification, phone, savedSettingsRoute]);

    useEffect(() => {
        if (messageQueue.length === 0) {
          return; // Return if no messages to process.
        }
        const message = messageQueue[messageQueue.length - 1];
        NotificationInfo.alert(messageQueue, () => onOpenNotification(message.external_id, message.notification_type, message.notification_id), true);

      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [messageQueue]);

    const onSelectCall = (uuid) => {
        dispatch({ type: 'CURRENT_CALL', uuid })
        dispatch({ type: 'CONTACT_LOOKUP', uuid });
        dispatch(leftSidebar.onSetActiveSecondarySidebar("view"))
        dispatch(office_view.onClosePhoneNotifications("CLOSE_CALL_NOTIFICATIONS"))
    }

    const onAnswerCall = (uuid, channel_uuid) => {
        if(settings === "settings"){
            //Settings Page
            navigate(savedSettingsRoute);
        }
        if(Object.keys(phone?.current?.Sessions)?.length > 1){
            phone?.current.holdOtherCalls(channel_uuid);
        }
        phoneUtils.handleDialerHoldOnAnswer(dialer, calls, userPhoneCreds, dispatch);
        if (uuid !== currentCall) {
            dispatch(office_view.currentCall('CURRENT_CALL', uuid));
            phoneUtils.loadContactHeader(calls, userPhoneCreds, uuid, dispatch);
        }
        dispatch(leftSidebar.onSetActiveSecondarySidebar("view"));
        dispatch(office_view.onClosePhoneNotifications("CLOSE_CALL_NOTIFICATIONS"));
        phone?.current.Answer(channel_uuid);
    }
    
    const onIgnoreCall = (uuid, channel_uuid) => {
        // phone?.current.HangUp(); //May add in future, incase BE endpoint fails
        dispatch(office_view.hangup({ pbx_hostname: calls[uuid].pbx, channel_uuid }));
        if(notificationCalls.length === 1){
            dispatch(contactsActions.removeViewLookup());
            dispatch(office_view.call(callTypes.IDLE_CALL));
        }
    }

    useEffect(() => {
        PhoneCallMessage.alert(displayedMessages, onSelectCall, onAnswerCall, onIgnoreCall, (!phoneUtils.isSoftPhone(phone) && isHardPhone));
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [displayedMessages]);

    const {
        onToggleModal,
        taskModalOpen,
        setTaskModalOpen,
        control,
        watch,
        isValid,
        isDirty,
        trigger,
        setValue,
        getValues,
        reset,
        isAllowedToModify,
        eventBeingEdited,
        handleSubmitEvent,
        resetField,
        taskControl,
        taskWatch,
        taskIsValid,
        taskIsDirty,
        taskTrigger,
        taskSetValue,
        taskGetValues,
        taskClearErrors,
        taskSetError,
        taskReset,
        taskBeingEdited,
        loadTask,
        addTask,
        state,
        setState,
        onDeleteTask,
        onUpdateTask,
        handleSubmit,
        task_labels,
        organizer_id,
        organizer,
        organizer_email,
        eventModalOpen,
        emailModalOpen,
        emailData,
        person_id,
        onDelete,
        onUpdate,
        setEventModalOpen,
        onOpenNotification,
        current_user,
        setNotificationContactName
    } = NotificationPopupModals();

    useEffect(() => {
        currentCallRef.current = currentCall;
    }, [currentCall])

    return (
        <>
            <SendEmailModal
                open={emailModalOpen}
                onClose={() => { if(emailModalOpen){onToggleModal("email", 0)} }}
                contact_id={person_id}
            />
            <AddTaskModal
                open={taskModalOpen}
                onClose={() => setTaskModalOpen(false)}
                state={state}
                control={taskControl}
                watch={taskWatch}
                isValid={taskIsValid}
                isDirty={taskIsDirty}
                trigger={taskTrigger}
                setValue={taskSetValue}
                getValues={taskGetValues}
                clearErrors={taskClearErrors}
                setError={taskSetError}
                reset={taskReset}
                taskBeingEdited={taskBeingEdited}
                loadTask={loadTask}
                addTask={addTask}
                setState={setState}
                onDelete={onDeleteTask}
                onUpdate={onUpdateTask}
                task_labels={task_labels}
                organizer_id={organizer_id}
                organizer={organizer}
                organizer_email={organizer_email}
                handleSubmit={handleSubmit}
                onRefresh={() => {
                    setTaskModalOpen(false);
                }}
                email={emailData} 
            />
            <AddEventModal
                open={eventModalOpen}
                onClose={() => setEventModalOpen(false)}
                onEdit={handleSubmitEvent(onUpdate)}
                onDeleteEvent={onDelete}
                eventBeingEdited={eventBeingEdited}
                selected_users={[current_user]}
                isAllowedToModify={isAllowedToModify}
                control={control}
                watch={watch}
                isValid={isValid}
                isDirty={isDirty}
                trigger={trigger}
                setValue={setValue}
                getValues={getValues}
                reset={reset}
                resetField={resetField}
                setNotificationContactName={setNotificationContactName}
                displayAllContacts
            />
        </>
    )
}

export default WebsocketConnection;

